import _classCallCheck from "E:\\Projects\\shl\\shl-frontend\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/classCallCheck";
import _createClass from "E:\\Projects\\shl\\shl-frontend\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/createClass";
/**
 *  PathLexeme.js
 *
 *  @copyright 2002, 2013 Kevin Lindsey
 *  @module PathLexeme
 */
/**
 *  PathLexeme
 */
var PathLexeme = /*#__PURE__*/function () {
  /**
   *  PathLexeme
   *
   *  @param {number} type
   *  @param {string} text
   */
  function PathLexeme(type, text) {
    _classCallCheck(this, PathLexeme);
    this.type = type;
    this.text = text;
  }

  /**
   *  Determine if this lexeme is of the given type
   *
   *  @param {number} type
   *  @returns {boolean}
   */
  _createClass(PathLexeme, [{
    key: "typeis",
    value: function typeis(type) {
      return this.type === type;
    }
  }]);
  return PathLexeme;
}();
/*
 * token type enumerations
 */
PathLexeme.UNDEFINED = 0;
PathLexeme.COMMAND = 1;
PathLexeme.NUMBER = 2;
PathLexeme.EOD = 3;
export default PathLexeme;